import * as palette from "@govlaunch/palette";
import React from "react";
import DisruptorD from "~/components/icons/DisruptorD";
import MakersIcon from "~/components/icons/MakersIcon";
import { Margin } from "~/components/spacings";
import Tooltip from "~/components/Tooltip";

interface ISectionHeaderMakerProps {
  target: "DISRUPTOR" | "MAKERS";
  disruptorTooltip: string;
  makersTooltip: string;
  children: React.ReactNode;
}

export default function SectionHeaderMaker({
  target = "MAKERS",
  disruptorTooltip,
  makersTooltip,
  children,
  ...props
}: ISectionHeaderMakerProps) {
  return (
    <div
      css={{
        borderBottom: `1px solid ${palette.lightestGray}`,
        padding: 15,
        textTransform: "uppercase",
        fontSize: 12,
        color: palette.darkGray,
        letterSpacing: 0.5,
        fontWeight: 500,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: palette.white,
      }}
      {...props}
    >
      {children}

      <Tooltip
        arrowSize={6}
        backgroundColor={target === "DISRUPTOR" ? "#9769ea" : palette.disruptiveGreen}
        render={() => (
          <div
            css={{
              padding: 8,
              fontWeight: "bold",
              color: palette.white,
              fontSize: 14,
            }}
          >
            {target === "DISRUPTOR" ? disruptorTooltip : makersTooltip}
          </div>
        )}
      >
        {({ innerRef, bind }) => (
          <Margin ml={5}>
            <div ref={innerRef} {...bind}>
              {target === "DISRUPTOR" && <DisruptorD width={18} height={18} />}

              {target === "MAKERS" && <MakersIcon width={18} height={18} />}
            </div>
          </Margin>
        )}
      </Tooltip>
    </div>
  );
}
